var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
var _react_refresh_temp_4;
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Menu } from '@headlessui/react';
import { createSelector } from '@reduxjs/toolkit';
import { Track } from 'livekit-client';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { updateSelectedVideoDevice } from '../../../../store/slices/roomSettingsSlice';
import { updateIsActiveWebcam, updateVirtualBackground, } from '../../../../store/slices/bottomIconsActivitySlice';
const videoDevicesSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.videoDevices);
$RefreshReg$(_react_refresh_temp_1, "videoDevicesSelector$createSelector");
const selectedVideoDeviceSelector = createSelector(_react_refresh_temp_2 = (state) => state.roomSettings, (roomSettings) => roomSettings.selectedVideoDevice);
$RefreshReg$(_react_refresh_temp_2, "selectedVideoDeviceSelector$createSelector");
const WebcamMenuItems = ({ currentRoom }) => {
    _react_refresh_temp_4();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const videoDevices = useAppSelector(videoDevicesSelector);
    const selectedVideoDevice = useAppSelector(selectedVideoDeviceSelector);
    const [devicesMenu, setDevicesMenu] = useState();
    const [newDevice, setNewDevice] = useState();
    useEffect(() => {
        const devicesMenu = videoDevices.map((device) => {
            return (_jsx("div", { className: "", role: "none", children: _jsx(Menu.Item, { children: () => (_jsx("p", { className: `${selectedVideoDevice === device.id
                            ? 'secondaryColor'
                            : 'text-gray-700 dark:text-darkText'} rounded group flex items-center px-3 py-[0.4rem] text-[10px] lg:text-xs transition ease-in hover:bg-primaryColor hover:text-white cursor-pointer`, onClick: () => setNewDevice(device.id), children: device.label })) }) }, device.id));
        });
        setDevicesMenu(devicesMenu);
    }, [selectedVideoDevice, videoDevices]);
    useEffect(() => {
        if (newDevice) {
            dispatch(updateSelectedVideoDevice(newDevice));
        }
    }, [newDevice, dispatch]);
    const leaveWebcam = () => {
        currentRoom.localParticipant.videoTracks.forEach(async (publication) => {
            if (publication.track &&
                publication.track.source === Track.Source.Camera) {
                currentRoom.localParticipant.unpublishTrack(publication.track, true);
            }
        });
        dispatch(updateIsActiveWebcam(false));
        dispatch(updateSelectedVideoDevice(''));
        dispatch(updateVirtualBackground({
            type: 'none',
        }));
    };
    return (_jsxs(Menu.Items, { static: true, className: "origin-bottom-right z-[9999] absolute ltr:left-0 rtl:-left-4 mt-2 w-40 bottom-[40px] rounded-md shadow-lg bg-white dark:bg-darkPrimary ring-1 ring-black dark:ring-secondaryColor ring-opacity-5 divide-y divide-gray-100 dark:divide-secondaryColor focus:outline-none", children: [devicesMenu, _jsx("div", { className: "", role: "none", children: _jsx(Menu.Item, { children: () => (_jsx("p", { className: "text-red-900 group flex rounded-md items-center text-left w-full px-2 py-[0.4rem] text-xs transition ease-in hover:bg-red-400 hover:text-white cursor-pointer", onClick: () => leaveWebcam(), children: t('footer.menus.leave-webcam') })) }) })] }));
};
_react_refresh_temp_3 = WebcamMenuItems;
$RefreshReg$(_react_refresh_temp_3, "WebcamMenuItems");
_react_refresh_temp_4(WebcamMenuItems, "/Xo8cIFpEjQ0yIqgHbgPqhHeCO8=", false, () => [useAppDispatch, useTranslation, useAppSelector, useAppSelector]);
export default WebcamMenuItems;
